import { useEffect, useState } from "react";
import ProductCard from "../productCard";
import { fetchMasterCategories } from "../../../node_modules/shops-query/src/modules/masterCategories";
import { getProductsController } from "../../../node_modules/shops-query/src/modules/products/index.js";
import { getProductsByCategoryController } from "../../../node_modules/shops-query/src/modules/productByCategory/index";
import { shopid } from "../../utils/url";
import { Link } from "react-router-dom";
import recommendedForYouImage from "../../assets/recommendedForYouImage.png";

const TrendingNow = ({ showCategories = true, excludeIds = [] }) => {
  const excludeArray = Array.isArray(excludeIds) ? excludeIds.map(id => String(id)) : [String(excludeIds)];
  const [isNullData, setIsNullData] = useState(false);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [products, setProducts] = useState([]);
  const [productsInSelectedCategory, setProductsInSelectedCategory] = useState(
    []
  );
  const [isLoading, setIsLoading] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);

  const handleScroll = (e) => {
    const element = e.target;
    const scrollLeft = element.scrollLeft;
    const scrollWidth = element.scrollWidth - element.clientWidth;
    const progress = (scrollLeft / scrollWidth) * 100;
    setScrollProgress(progress);
  };

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const catData = await fetchMasterCategories(shopid);
        setCategories(catData);
      } catch (error) {
        console.log("Something went wrong while getting categories", error);
      }
    };
    fetchCategories();
  }, []);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await getProductsController(shopid, null);
        if (res?.data?.products) {
          setProducts(res.data.products);
        } else if (Array.isArray(res)) {
          setProducts(res);
        } else {
          setProducts([]);
        }
      } catch (error) {
        console.error("An error occurred:", error);
        // Sometimes GraphQL throws error but still has data
        if (error?.response?.data?.data?.products) {
          setProducts(error.response.data.data.products);
        }
      } finally {
        setIsLoading(false);
      }
    };

    fetchProducts();
  }, []);

  const getProductsByCategories = async (catName) => {
    try {
      setIsLoading(true);
      setIsNullData(false);
      const catData = await getProductsByCategoryController(catName, shopid);
      if (!catData || catData.length === 0) {
        setIsNullData(true);
      }
      setProductsInSelectedCategory(catData);
    } catch (error) {
      console.log(
        "Something went wrong while fetching master categories",
        error
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleCategoryClick = (c) => {
    getProductsByCategories(c.category);
    setSelectedCategory(c.category);
  };

  return (
    <div className="font-poppins mt-10 w-full ">
      {/* Main container with responsive padding */}
      <div className="w-full mx-auto ">
        {/* Header Removed as per new design */}

        {/* Categories Removed as per new design */}

        {/* Product Section */}
        <div className="pb-6 sm:pb-8 md:pb-12 lg:pb-20 md:mt-[24px]">
          {selectedCategory === "All" ? (
            <>
              {/* Header */}
              <div className="flex items-center justify-between mb-4 md:mb-6">
                <p className="font-semibold text-[18px] sm:text-[22px] md:text-[28px] uppercase text-black">
                  RECOMMENDED FOR YOU
                </p>
                <Link to="/all-products">
                  <p className="font-semibold text-[14px] md:text-[18px] uppercase text-[#FF4C24] underline underline-offset-4 cursor-pointer">
                    VIEW ALL
                  </p>
                </Link>
              </div>

              {/* MOBILE & DESKTOP: Horizontal Scroll */}
              <div
                className="flex gap-4 sm:gap-8 w-full overflow-x-auto black-scrollbar pb-6 cursor-pointer"
              >
                {products
                  ?.filter((item) => !excludeArray.includes(String(item.id)))
                  .slice(0, 10)
                  .map((item) => (
                    <div
                      key={item?.id}
                      className="min-w-[calc(45vw)] md:min-w-[calc(25%-24px)] flex-shrink-0"
                    >
                      <ProductCard
                        item={item}
                        tag=""
                        showHeart={true}
                        isThisWishlistPage={false}
                      />
                    </div>
                  ))}
              </div>
            </>
          ) : isLoading ? (
            <div className="w-full flex justify-center items-center py-10">
              <p className="text-center text-neutral-grey-2 text-[16px] sm:text-[18px]">
                Loading Products.....
              </p>
            </div>
          ) : isNullData ? (
            <div className="w-full flex justify-center items-center py-10">
              <p className="text-center text-neutral-grey-2 text-[16px] sm:text-[18px]">
                No Products Found
              </p>
            </div>
          ) : (
            <>
              {/* Header for Category View */}
              <div className="flex items-center justify-between mb-4 md:mb-6">
                <p className="font-semibold text-[18px] sm:text-[22px] md:text-[28px] uppercase text-black">
                  Recommended - {selectedCategory}
                </p>
                <Link to="/all-products">
                  <p className="font-semibold text-[14px] md:text-[18px] uppercase text-[#FF4C24] underline underline-offset-4 cursor-pointer">
                    VIEW ALL
                  </p>
                </Link>
              </div>

              {/* UNIFIED SCROLL */}
              <div
                className="flex gap-4 sm:gap-8 w-full overflow-x-auto black-scrollbar pb-6"
              >
                {productsInSelectedCategory
                  ?.filter((item) => !excludeArray.includes(String(item.id)))
                  .slice(0, 10)
                  .map((item) => (
                    <div
                      key={item?.id}
                      className="min-w-[calc(45vw)] md:min-w-[calc(25%-24px)] flex-shrink-0"
                    >
                      <ProductCard
                        item={item}
                        tag=""
                        showHeart={true}
                        isThisWishlistPage={false}
                      />
                    </div>
                  ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default TrendingNow;
